import React from 'react';
import PT from 'prop-types';
import { ResponsivenessGrid } from '../toolkit';
import TranslatorManager from 'ts-translate-js';
import moment from  'moment';
import "moment-timezone";
import cIf from 'classnames';

const tr = TranslatorManager.boundTR;

export function ContactUs({ clientEnterpriseName, localPhone, tollFreePhone, fax, infoEmailAddress, coordinates, integ }) {
    const easternCurrentTime = moment.tz('America/Toronto').format('z'); // Check if we are in daylight saving or not
    const currentTz = (easternCurrentTime == "EDT") ? tr('HAE') : tr('HNE');
    
    return (
        <div className={cIf([integ])}>
            <h2>{tr("Nous joindre")}</h2>
            <ResponsivenessGrid 
                nbrColumnsByBreakpointConfigs={{ mobile: 1, tablet: 2, small: 3, large: 3 }}
                items={[ <div key="address">
                    <h3>{tr(`Administration`)}</h3>
                    <address>
                        <b>
                            {clientEnterpriseName}<br />
                            {coordinates?.address1 || tr("930 boul. Jacques-Cartier Est")},<br />
                            {coordinates?.address2 || tr("Bureau B-101")}<br />
                            {coordinates?.city || tr("Chicoutimi")}, {tr("(Québec)")}<br />
                            {coordinates?.postalCode || tr("G7H 7K9")}
                        </b>
                    </address>
                </div>,
                <div key="phone">
                    <h3>&nbsp;</h3>
                    <div><b>{tr(`Téléphone :`)}</b> {localPhone}</div>
                    <div><b>{tr(`Téléphone sans frais :`)}</b> {tollFreePhone}</div>
                    <div><b>{tr(`Télécopieur :`)}</b> {fax}</div>
                    <div><b>{tr(`Courriel :`)}</b><a href={`mailto:${infoEmailAddress}`}> {infoEmailAddress}</a></div>
                </div>,
                <div key="officeHours">
                    <h3>{tr(`Heures d'affaires`)}</h3>
                    <h5>{tr("Bureau administratif")}</h5>
                    <div><b>{tr("Lundi au vendredi")}</b> - {tr("8h à 16h {timezone}", {timezone: currentTz})}<br /></div>
                    <div><b>{tr("Samedi et dimanche")}</b> - {tr("Fermé")}<br /></div>
                    <h5>{tr("Centrale téléphonique")}</h5>
                    <div><b>{tr("Lundi au vendredi")}</b> - {tr("9h à 20h {timezone}", {timezone: currentTz})}<br /></div>
                    <div><b>{tr("Samedi et dimanche")}</b> - {tr("10h à 17h {timezone}", {timezone: currentTz})}<br /></div>
                </div>
                ]}
            />
        </div>
    );
}
ContactUs.propTypes = {
    clientEnterpriseName: PT.string,
    localPhone: PT.string,
    tollFreePhone: PT.string,
    fax: PT.string,
    infoEmailAddress: PT.string,
    coordinates: PT.object,
    integ: PT.string
};
